import * as React from "react";
import {Static} from "@bizform/type/decorator/Static.decorator";
import {ComponentElement, ComponentElementStatic} from "@bizform/type/model/component_element/ComponentElement.model";
import {PluginType} from "@bizform/type/model/model/Plugin.model";
import {WindowKey} from "@bizform/type/model/model/WindowKey.model";
import {
    ComponentCategory,
    ComponentElementManifest,
    ComponentElementProperty
} from "@bizform/type/model/component_element/ComponentElementManifest.model";
import {DataType} from "@bizform/type/model/model/DataType.model";
import {DefaultLayoutId} from "@bizform/type/model/component_element/DefaultLayoutId.model";
import {
    ComponentElementClass,
    FormValidationService,
    ReactComponentElementInit
} from "@bizform/core/dist/js/bizflow/core.min";


type Props =  {
};

type State =  {
    show: boolean;
};

/**
 * Custom Validation Handler
 *
 * @since 0.0.1
 * @author Heungsoo Ham
 * @class
 */
@ComponentElementClass()
@Static<ComponentElementStatic<null>>()
export class BfCustomValidation extends React.Component<Props, State> implements ComponentElement<null> {
    static readonly pluginType: string = PluginType.DATALINKHANDLER;

    /* manifest */
    static readonly componentElementManifest: ComponentElementManifest = {
        uniqueId: "_2Kxr2cDRVU4Nqty0LVFxTuvZA9Fu5k6",
        category: ComponentCategory.HANDLER,
        label: "Custom Validation Handler",
        description: "Custom Validation Handler",
        icon: "",
        defaultLayoutId: DefaultLayoutId.ONLYCOMPONENTELEMENT,
        property: null
    };

    destroyed: boolean;
    accessibility: boolean;
    elementId: string;
    applicationId: string;
    formId: string;
    dataType: DataType;
    parentDom: HTMLElement;

    /** action */
    emit(value: null) {}
    subscription(value: null) {}
    onDisabled() {
        this._show();
    }
    onReadOnly() {
        this._show();
    }
    onPrint() {
        this._show();
    }
    onEdit() {
        this._show();
    }

    setProperty(property: ComponentElementProperty) {
        FormValidationService.regValidationHandler((this as any).___props);
    }

    @ReactComponentElementInit(BfCustomValidation)
    static init(): ComponentElement<string> {
        return;
    }

    initDone(): void {
    }

    destroy(): void {
        FormValidationService.removeValidationHandler((this as any).___props);
        this.destroyDone();
    }

    destroyDone(): void {
    }

    /* for React */
    props: Props;
    state: State;
    private _ref: HTMLInputElement;

    constructor(props?: Props) {
        super(props);
        this.state = {
            show: false
        };
    }

    shouldComponentUpdate(nextProps: Readonly<Props>, nextState: Readonly<State>, nextContext: any): boolean {
        return this.state.show !== nextState.show;
    }

    render(): React.ReactNode {
        if (this.state.show && (window[WindowKey.DESIGNMODE] || window[WindowKey.VERSIONMODE]) && this.elementId) {
            return (
                <div className={"w-100 h-100 text-center p-1"} style={{fontSize: "12px", "border": "2px dashed green", "backgroundColor": "rgba(0, 255, 0, 0.1)"}}><b className={"bf-text-green7"}>Custom Validation Handler (Function only works under editable)</b></div>
            );
        } else {
            return null;
        }
    }

    private _show() {
        this.setState({
            show: true
        });
    }
}
